exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".react-tel-input .form-control {\n  border-radius: inherit;\n  width: inherit;\n}\n", ""]);

// exports
